import React from 'react';

// Legacy Pagination component interface for backward compatibility
interface PaginationProps {
  take: number;
  page: number;
  total: number;
  setPage: (page: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({
  take,
  page,
  total,
  setPage,
}) => {
  const totalPages = Math.ceil(total / take);
  const hasNext = page < totalPages;
  const hasPrev = page > 1;

  return (
    <div className="flex w-full items-center justify-between px-4 py-3 border-t border-gray-200 sm:px-6">
      <div className="flex items-center gap-4">
        <div>
          <p className="text-sm text-gray-700">
            Showing <span className="font-medium">{(page - 1) * take + 1}</span>{' '}
            to{' '}
            <span className="font-medium">{Math.min(page * take, total)}</span>{' '}
            of <span className="font-medium">{total}</span> results
          </p>
        </div>
      </div>

      <div>
        <nav
          className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px"
          aria-label="Pagination">
          <button type="button"
            onClick={() => setPage(page - 1)}
            disabled={!hasPrev}
            className="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed">
            <span className="sr-only">Previous</span>
            <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
              <path
                fillRule="evenodd"
                d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                clipRule="evenodd"
              />
            </svg>
          </button>

          <span className="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700">
            Page {page} of {totalPages}
          </span>

          <button type="button"
            onClick={() => setPage(page + 1)}
            disabled={!hasNext}
            className="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed">
            <span className="sr-only">Next</span>
            <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
              <path
                fillRule="evenodd"
                d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                clipRule="evenodd"
              />
            </svg>
          </button>
        </nav>
      </div>
    </div>
  );
};

export { Pagination };
export default Pagination;
